var React = require('react');

function IconStarInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.7589 0L16.8894 9.6347H27.0199L18.8242 15.5893L21.9547 25.224L13.7589 19.2694L5.56313 25.224L8.69364 15.5893L0.497871 9.6347H10.6284L13.7589 0Z","fill":"currentColor"}));
}

IconStarInline.defaultProps = {"width":"28","height":"26","viewBox":"0 0 28 26","fill":"none"};

module.exports = IconStarInline;

IconStarInline.default = IconStarInline;
